import React, { lazy } from 'react';
import { dashboardPagesMenu, demoPagesMenu, pageLayoutTypesPagesMenu } from '../menu';
import Login from '../pages/presentation/auth/Login';

const LANDING = {
	DASHBOARD: lazy(() => import('../pages/presentation/dashboard/DashboardPage')),
};

const AUTH = {
	PAGE_404: lazy(() => import('../pages/presentation/auth/Page404')),
};

const PAGE_LAYOUTS = {
	/**
	 * Employee ROUTES
	 */
	ADD_EMPLOYEE: lazy(() => import('../pages/presentation/page-layouts/employees/AddEmployee')),
	LIST_EMPLOYEES: lazy(
		() => import('../pages/presentation/page-layouts/employees/ListEmployees'),
	),
	EDIT_EMPLOYEE: lazy(() => import('../pages/presentation/page-layouts/employees/EditEmployee')),
	DETAIL_EMPLOYEE: lazy(
		() => import('../pages/presentation/page-layouts/employees/VeiwEmployeeDetail'),
	),

	/**
	 * Leave ROUTES
	 */
	ADD_LEAVE: lazy(() => import('../pages/presentation/page-layouts/leaves/AddLeave')),
	LIST_LEAVES: lazy(() => import('../pages/presentation/page-layouts/leaves/ListLeaves')),
	LIST_LEAVE_BALANCE: lazy(
		() => import('../pages/presentation/page-layouts/leaves/LeaveBalance'),
	),
	LIST_EMP_LEAVES: lazy(
		() => import('../pages/presentation/page-layouts/leaves/MyRequestedLeaves'),
	),

	/**
	 * Attendance ROUTES
	 */
	MARK_ATTENDANCE: lazy(
		() => import('../pages/presentation/page-layouts/attendance/MarkAttendance'),
	),
	LIST_ATTENDANCE: lazy(
		() => import('../pages/presentation/page-layouts/attendance/ListAttendance'),
	),
	ATTENDANCE_DETAIL: lazy(
		() => import('../pages/presentation/page-layouts/attendance/AttendanceDetail'),
	),

	/**
	 * Roles ROUTES
	 */
	ADD_ROLE: lazy(() => import('../pages/presentation/page-layouts/role/AddRole')),
	LIST_ROLES: lazy(() => import('../pages/presentation/page-layouts/role/ListRole')),
	EDIT_ROLES: lazy(() => import('../pages/presentation/page-layouts/role/EditRole')),

	/**
	 * Device ROUTES
	 */
	ADD_DEVICE: lazy(() => import('../pages/presentation/page-layouts/device/AddDevice')),
	LIST_DEVICE: lazy(() => import('../pages/presentation/page-layouts/device/ListDevice')),

	/**
	 * LIST CONFIGURATION ROUTES
	 */
	LIST_CONFIGURATION: lazy(
		() => import('../pages/presentation/page-layouts/Settings/Configuration/ListConfiguration'),
	),

	/**
	 * PUBLIC HOLIDAY ROUTES
	 */
	ADD_HOLIDAY: lazy(() => import('../pages/presentation/page-layouts/holidays/AddHolidays')),
	LIST_HOLIDAY: lazy(() => import('../pages/presentation/page-layouts/holidays/ListHolidays')),

	/**
	 * LIST ACTIVITY LOGS ROUTES
	 */
	LIST_ACTIVITY_LOGS: lazy(
		() => import('../pages/presentation/page-layouts/activityLogs/ListActivityLogs'),
	),

	/**
	 * LIST SYSTEM LOGS ROUTES
	 */
	LIST_SYSTEM_LOGS: lazy(
		() => import('../pages/presentation/page-layouts/systemLogs/ListSystemLogs'),
	),

	/**
	 *  SUPER ADMIN PROFILE
	 */
	UPDATE_SUPER_ADMIN_PROFILE: lazy(
		() => import('../pages/presentation/page-layouts/profile/UpdateSuperAdminProfile'),
	),
};

export const publicPages = [
	{
		path: dashboardPagesMenu.dashboard.path,
		element: <LANDING.DASHBOARD />,
	},
	{
		path: demoPagesMenu.page404.path,
		element: <AUTH.PAGE_404 />,
	},
	{
		path: demoPagesMenu.login.path,
		element: <Login />,
	},
	{
		path: pageLayoutTypesPagesMenu.profile.path,
		element: <PAGE_LAYOUTS.UPDATE_SUPER_ADMIN_PROFILE />,
	},
];


/**
 * ============================================================
 * AUTHENTICATED APPLICATION ROUTES
 * ============================================================
 */

export const authPages = [
	/* ============================================================
	 * EMPLOYEE MANAGEMENT ROUTES
	 * ------------------------------------------------------------
	 * Handles employee CRUD operations and detail views
	 * ============================================================
	 */
	{
		path: pageLayoutTypesPagesMenu.employee.subMenu.addEmployee.path,
		element: <PAGE_LAYOUTS.ADD_EMPLOYEE />,
	},
	{
		path: pageLayoutTypesPagesMenu.employee.subMenu.listEmployees.path,
		element: <PAGE_LAYOUTS.LIST_EMPLOYEES />,
	},
	{
		path: pageLayoutTypesPagesMenu.employee.subMenu.editEmployee.path,
		element: <PAGE_LAYOUTS.EDIT_EMPLOYEE />,
	},
	{
		path: pageLayoutTypesPagesMenu.employee.subMenu.employeeDetail.path,
		element: <PAGE_LAYOUTS.DETAIL_EMPLOYEE />,
	},

	/* ============================================================
	 * ATTENDANCE MANAGEMENT ROUTES
	 * ------------------------------------------------------------
	 * Attendance listing, marking, and detailed records
	 * ============================================================
	 */
	{
		path: pageLayoutTypesPagesMenu.attendance.subMenu.listAttendance.path,
		element: <PAGE_LAYOUTS.LIST_ATTENDANCE />,
	},
	{
		path: pageLayoutTypesPagesMenu.attendance.subMenu.markAttendance.path,
		element: <PAGE_LAYOUTS.MARK_ATTENDANCE />,
	},
	{
		path: pageLayoutTypesPagesMenu.attendance.subMenu.attendanceDetail.path,
		element: <PAGE_LAYOUTS.ATTENDANCE_DETAIL />,
	},

	/* ============================================================
	 * LEAVE MANAGEMENT ROUTES
	 * ------------------------------------------------------------
	 * Employee leave requests, balances, and approvals
	 * ============================================================
	 */
	{
		path: pageLayoutTypesPagesMenu.leaves.subMenu.requestaddLeaves.path,
		element: <PAGE_LAYOUTS.ADD_LEAVE />,
	},
	{
		path: pageLayoutTypesPagesMenu.leaves.subMenu.listRequestleaves.path,
		element: <PAGE_LAYOUTS.LIST_LEAVES />,
	},
	{
		path: pageLayoutTypesPagesMenu.leaves.subMenu.listleavesBalance.path,
		element: <PAGE_LAYOUTS.LIST_LEAVE_BALANCE />,
	},
	{
		path: pageLayoutTypesPagesMenu.leaves.subMenu.employeeRequestedLeaves.path,
		element: <PAGE_LAYOUTS.LIST_EMP_LEAVES />,
	},

	/* ============================================================
	 * ROLE & PERMISSION ROUTES
	 * ------------------------------------------------------------
	 * Role creation, listing, and permission management
	 * ============================================================
	 */
	{
		path: pageLayoutTypesPagesMenu.roles.subMenu.addRole.path,
		element: <PAGE_LAYOUTS.ADD_ROLE />,
	},
	{
		path: pageLayoutTypesPagesMenu.roles.subMenu.listRole.path,
		element: <PAGE_LAYOUTS.LIST_ROLES />,
	},
	{
		path: pageLayoutTypesPagesMenu.roles.subMenu.editRole.path,
		element: <PAGE_LAYOUTS.EDIT_ROLES />,
	},

	/* ============================================================
	 * DEVICE MANAGEMENT ROUTES
	 * ============================================================
	 */
	{
		path: pageLayoutTypesPagesMenu.device.subMenu.addDevice.path,
		element: <PAGE_LAYOUTS.ADD_DEVICE />,
	},
	{
		path: pageLayoutTypesPagesMenu.device.subMenu.listDevice.path,
		element: <PAGE_LAYOUTS.LIST_DEVICE />,
	},

	/* ============================================================
	 * HOLIDAY MANAGEMENT ROUTES
	 * ------------------------------------------------------------
	 * Company holidays creation and listing
	 * ============================================================
	 */
	{
		path: pageLayoutTypesPagesMenu.holiday.subMenu.addHoliday.path,
		element: <PAGE_LAYOUTS.ADD_HOLIDAY />,
	},
	{
		path: pageLayoutTypesPagesMenu.holiday.subMenu.listHoliday.path,
		element: <PAGE_LAYOUTS.LIST_HOLIDAY />,
	},

	/* ============================================================
	 * SYSTEM CONFIGURATION ROUTES
	 * ------------------------------------------------------------
	 * Application-wide configurations
	 * ============================================================
	 */
	{
		path: pageLayoutTypesPagesMenu.settings.subMenu.listConfiguration.path,
		element: <PAGE_LAYOUTS.LIST_CONFIGURATION />,
	},

	/* ============================================================
	 * LOGS ROUTES
	 * ------------------------------------------------------------
	 * Activity logs and system-level audit trails
	 * ============================================================
	 */
	{
		path: pageLayoutTypesPagesMenu.logs.subMenu.listActiviyLogs.path,
		element: <PAGE_LAYOUTS.LIST_ACTIVITY_LOGS />,
	},
	{
		path: pageLayoutTypesPagesMenu.logs.subMenu.listSystemLogs.path,
		element: <PAGE_LAYOUTS.LIST_SYSTEM_LOGS />,
	},
];